import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import {Button, Divider, Box} from '@material-ui/core';
import i18n from './i18n';

export default function ListAgg({aggregatorList, onClickAdd, onDeleteItem}) {
  return (
    <>
      <Divider style={{marginTop: '5px', marginBottom: '5px'}} />
      <Box
        alignItems="center"
        component="div"
        display="flex"
        flexDirection="column"
      >
        <Button
          variant="contained"
          style={{textAlign: 'center'}}
          onClick={() => onClickAdd()}
        >
          {i18n.getMessage('Adicionar Métrica')}
        </Button>
        <List
          style={{
            margin: 0,
            marginTop: 5,
            backgroundColor: 'white',
            width: '100%',
          }}
          dense={true}
          disablePadding
        >
          {aggregatorList?.map((e, i) => (
            <ListItem key={i} divider>
              <ListItemText
                primary={`${i18n.getMessage(e.aggregatorName)}`}
                secondary={`(${e.vals.join(',')})`}
              />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={() => onDeleteItem(i)}
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Box>
    </>
  );
}
